import colors from '@theme/colors';
import { scale } from '@utils/normalize';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  // tooltipContainerStyle: {
  //   backgroundColor: colors.neutral.charcoal,
  //   borderRadius: scale(8),
  //   paddingHorizontal: scale(12),
  //   paddingVertical: scale(8),
  //   alignSelf: 'center',
  //   // this ensures text doesn't overflow:
  //   flexShrink: 1,
  // },

  backdrop: {
    alignItems: 'center',
    backgroundColor: colors.overlay.backdropLight,
    flex: 1,
    justifyContent: 'center',
  },
  fullscreenOverlay: {
    backgroundColor: colors.transparent,
    flex: 1,
    position: 'relative',
  },

  tooltipContainerStyle: {
    backgroundColor: colors.neutral.charcoal,
    borderRadius: scale(8),
    elevation: 5,
    padding: scale(8),
    shadowColor: colors.shadow.black,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 4,
  },
});
export default styles;
